import dayjs, { Dayjs } from 'dayjs';
import "dayjs/plugin/utc";

require('dayjs/locale/nl');
require('dayjs/locale/en');

var localizedFormat = require('dayjs/plugin/localizedFormat');
var utc = require('dayjs/plugin/utc');

dayjs.extend(localizedFormat);
dayjs.extend(utc);

export const formatDate = (input: string | Date, format: string = 'LL', language?: string): string => {
    
    if(input) {
        var date = dayjs.utc(input);
        
        if (language) {
            date = date.locale(language.toLowerCase());
        }
        
        return date.format(format);
    }

    return input;
}

export const currentDate = (): string => {
    let t = new Date();
    return `${t.getFullYear()}-${('0' + (t.getMonth() + 1)).slice(-2)}-${('0' + t.getDate()).slice(-2)}T00:00:00Z`;
}

export const isToday = (date: string): boolean => {
    let t = new Date();
    let dateFull = `${t.getFullYear()}-${('0' + (t.getMonth() + 1)).slice(-2)}-${('0' + t.getDate()).slice(-2)}`
    return dateFull === date;
}

export const isPast = (date: string): boolean => {
    let today = new Date().getTime();
    return isToday(date) || new Date(date).getTime() < today;
}